import { makeStyles } from '@material-ui/core/styles'
import { customColor } from '../../../../theme/theme'
// TODO Bring Back Unique Colors
export const tempStyles = makeStyles((theme) => ({
  container: {
    padding: 0,
  },
  subtitleSpan: {
    fontWeight: 'normal',
  },
  selectContainer: {
    width: 320,
    marginTop: 7,
    [theme.breakpoints.down(400)]: {
      width: 285,
    },
  },
  selector: {
    width: '100%',
    height: 35,
  },
  greyBackground: {
    backgroundColor: theme.palette.background.default,
  },
  ruListContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: 356,
    maxHeight: 356,
    width: 335,
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 318px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  rbhsListContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: 411,
    maxHeight: 411,
    width: 335,
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 263px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  bothruListContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: 320,
    maxHeight: 320,
    width: 335,
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 353px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  bothrbhsListContainer: {
    overflowY: 'auto',
    overflowX: 'hidden',
    height: 320,
    maxHeight: 320,
    width: 335,
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 353px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  bottomListContainer: {
    display: 'flex',
    height: 62,
    borderTop: `1px solid ${theme.palette.base.lightGray}`,
  },
  bottomListText: {
    color: theme.palette.primary.headerText,
    fontSize: 12,
  },
  bottomListTextDisabled: {
    color: theme.palette.grey,
    fontSize: 12,
  },
  bottomListButton: {
    height: '100%',
  },
  text: {
    fontWeight: 700,
  },
  sectionTitle: {
    marginRight: 10,
    fontSize: 12,
    fontWeight: 700,
  },
  rowSection: {
    paddingLeft: 8,
  },
  rightInfoContainer: {
    marginLeft: '1rem',
  },
  icon: {
    color: customColor.rutgersRed,
  },
  table: {
    minWidth: 200,
  },
  tableAdditionalHeader: {
    fontWeight: 'bold',
  },
  courseScheduleDialog: {
    height: '100%',
    [theme.breakpoints.down(570)]: {
      height: 'calc(100dvh - 55px) !important',
    },
  },
  courseAnchor: {
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    '&:hover': {
      color: '#ffffff',
    },
  },
  award: {
    marginTop: 15,
    margin: 10,
    padding: 5,
    backgroundColor: theme.palette.backgroundColor.ternary,
  },
  titleStyle: {
    fontWeight: 'bold',
  },
}))

export default tempStyles
